import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

const StepEvidencias = ({ evidencias, onChange, onSave, readOnly }) => (
  <Card>
    <CardHeader><CardTitle>Evidências e Aprofundamento</CardTitle></CardHeader>
    <CardContent className="space-y-4">
      <Textarea value={evidencias?.observacoes || ""} disabled={readOnly} onChange={(e) => onChange({ ...evidencias, observacoes: e.target.value })} />
      {!readOnly && <Button onClick={onSave}>Salvar</Button>}
    </CardContent>
  </Card>
);

export default StepEvidencias;
